import { useTranslation } from "react-i18next"

import Input from "../../../../../../../Components/Input"
import { tLiteral } from "../../../utils/questionText"

// text and url share one control. A url field accepts input without a protocol and
// prepends https:// on blur, so the merchant can just type "website.com"; a value that
// already carries a protocol (or is empty) is left alone.
const TextControl = ({ question, value, status, onChange, onTouch }) => {
  const { t } = useTranslation()

  const handleBlur = () => {
    if (question.type === "url") {
      const v = String(value ?? "").trim()
      if (v && !/^https?:\/\//i.test(v)) onChange(`https://${v}`)
    }
    onTouch()
  }

  return (
    <Input
      value={value ?? ""}
      placeholder={tLiteral(t, question.placeholder)}
      onChange={(e) => onChange(e.target.value)}
      onBlur={handleBlur}
      status={status}
    />
  )
}

export default TextControl
